<template>
  <div class="flex-grow">
      <BlogCard
        :imageSrc="archiImageSrc"
        text="Architecture serverless et sa structuration - l'exemple de ce site"
        to="/blog/architecture-101"
    />
   <BlogCard
        :imageSrc="cdkImageSrc"
        text="CDK ou pas .. - le choix est vite fait - j'aime définitivement pas CDK"
      to="/blog/cdk-101"
    />
    <BlogCard
        :imageSrc="dipImageSrc"
        text="DIP - Dependancies Inversion Principle"
      to="/blog/dip-101"
    />
  </div>
</template>

<script>
import BlogCard from '@/components/BlogCard.vue';
export default {
  name: 'BlogView',
  components: {
    BlogCard,
  },
  data() {
    return {
      cdkImageSrc: require('@/assets/blog/cdk.png'),
      archiImageSrc: require('@/assets/blog/archi.png'),
      dipImageSrc: require('@/assets/blog/dpi.webp'),
    };
  },
}
</script>
